
import {useState} from "react";
import ApiRoute from "../../helper/api";
import Modal from "../Utilities/Modal";
import BrandSelect from "../Product/Category/BrandSelect";

export default function CreatePriceRuleBrandModal({closeModal, ruleId, event}){

    const [text, setText] = useState('')
    const [brands, setBrands] = useState([])
    async function handleSubmit(){
        const res = await ApiRoute.price.rule.createBrand.fn(ruleId,{
            title : text,
            brands: brands
        })
        try {
            event(res)
        }catch (e) {
            
        }
    }
    return (
        <Modal isOpen={true} onClose={closeModal}>
            <div>

                <div className="page-title z-1 text-right text-sm">
                    <span className="inline-block bg-white pl-3 pr-1 mb-3 relative z-2">ایجاد برند</span>
                </div>

                <div className={`flex gap-2 w-full flex-col`}>

                    <input onKeyUp={ (e) => { setText(e.target.value) } } className='px-3 py-2 border border-[#dfdfdf] w-full rounded-[8px] shadow flex-auto bg-white' type="text" placeholder="عنوان را بنویسد ..."/>
                    <BrandSelect fixed={true} assignItem={ (v) => {
                       let arr = []
                        v.map( (x) => {
                            arr.push(x.value)
                        } )
                        setBrands(arr)
                    } }/>
                    <button onClick={handleSubmit} className={`btn-green w-24 rounded`}>ایجاد</button>

                </div>

            </div>
        </Modal>
    )
}